import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';

export const LenderApi = {
  hostName: 'consumerPortalApi',
  url: 'lender/config'
} as DataLoadURL;

export const InitAppApi = {
  hostName: 'consumerPortalApi',
  url: 'appInit'
} as DataLoadURL;

export const excludeFlowIds = [
  'heloc',
  'ola',
  'ola-consumer/purchase',
  'ola-consumer/refinance',
  'ola-consumer/personal',
  'ola-consumer/cc',
  'ola-consumer/secured',
  'ola-consumer/usedvehicle',
  'ola-consumer/signatureloan',
  'ola-consumer/newvehicle',
  'ola-consumer/boatandrv',
  'ola-consumer/holidayloan',
  'ola-consumer/vacationloan',
  'ola-consumer/applianceloan',
  'ola-consumer/motorcycle',
  'ola-consumer/ploc',
  'ola-consumer/autosmart',
  'oao'
];
